import React from 'react';
import ReactDOM from 'react-dom/client';
import "./index.css";
import App from './App';

// const functions = require("firebase-functions");
// const { saveHistoryOnUpdate } = require("../functions/historyLogger");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Firestore の onUpdate トリガーを登録
// exports.saveHistoryOnUpdate = saveHistoryOnUpdate;